import { ApolloLink } from '@apollo/client'

import { map } from 'rxjs/operators'

export const executionTimeLink = new ApolloLink((operation, forward) => {
  operation.setContext({ initTime: performance.now() })

  try {
    return forward(operation).map(data => calculateExecutionTime(data, operation))
  } catch {
    return forward(operation).pipe(map(data => calculateExecutionTime(data, operation)))
  }
})

const calculateExecutionTime = (data, operation) => {
  const executionTime = performance.now() - operation.getContext().initTime
  operation.setContext({ executionTime })
  return data
}
